import * as Popover from "@radix-ui/react-popover";
import { Link } from "lucide-react";
import { IframeLinkEditorPanel } from "../../../panels/IframeLinkEditorPanel/IframeLinkEditorPanel.js";
import { Icon } from "../../../ui/Icon.js";
import { Toolbar } from "../../../ui/Toolbar.js";
import i18next from "i18next";

export type EditIframeLinkPopoverProps = {
  onSetLink: (src: string) => void;
  initialSrcLink: string;
};

export const EditIframeLinkPopover = ({
  onSetLink,
  initialSrcLink,
}: EditIframeLinkPopoverProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Toolbar.Button type="button"
          tooltip={i18next.t("setEmbedCodeOrLink") || "Set Embed Code / Embed Link"}
        >
          <Icon icon={Link} />
        </Toolbar.Button>
      </Popover.Trigger>
      <Popover.Content>
        <IframeLinkEditorPanel
          onSetLink={onSetLink}
          initialSrc={initialSrcLink ?? ""}
        />
      </Popover.Content>
    </Popover.Root>
  );
};
